import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/file.png'


const _withScopeId = n => (_pushScopeId("data-v-1f1505d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12 p-mt-6" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-col-11" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-pb-6" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "file-icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "p-text-bold" }
const _hoisted_10 = { class: "period" }
const _hoisted_11 = { class: "status-block p-d-flex p-ai-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status" }, null, -1))
const _hoisted_13 = { class: "status-tittle" }
const _hoisted_14 = { class: "p-d-flex p-justify-center" }
const _hoisted_15 = {
  key: 0,
  class: "period"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "period"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["src"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-more" }, "...", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "orders-subtable p-flex-column" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "channel-title" }
const _hoisted_29 = { class: "p-flex-column stat-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "total clicks", -1))
const _hoisted_31 = { class: "stats-channel" }
const _hoisted_32 = { class: "p-flex-column stat-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "TOTAL intalls", -1))
const _hoisted_34 = { class: "stats-channel" }
const _hoisted_35 = {
  class: "p-flex-column stat-item",
  style: {"flex-grow":"1"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Monthly earnings so far", -1))
const _hoisted_37 = {
  key: 0,
  class: "stats-channel"
}
const _hoisted_38 = {
  key: 0,
  class: "stats-channel"
}
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "button-more" }, "...", -1))
const _hoisted_42 = [
  _hoisted_41
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_DataTable, {
          value: $setup.latestContractesMyArray,
          responsiveLayout: "scroll",
          rows: 8,
          expandedRows: $setup.expandedRows,
          "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event: any) => (($setup.expandedRows) = $event)),
          dataKey: "id"
        }, {
          empty: _withCtx(() => [
            _createTextVNode("No data found.")
          ]),
          loading: _withCtx(() => [
            _createTextVNode("Loading data... Please wait.")
          ]),
          expansion: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentRowWorkers(slotProps?.data), (channel, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-d-flex p-align-center p-mb-2 p-mt-2 hover-item",
                  key: `${idx}_f`
                }, [
                  _createElementVNode("img", {
                    class: "influencer-img influencer-img-big",
                    src: channel?.channel?.photo
                  }, null, 8, _hoisted_27),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(channel?.channel?.title), 1),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, _toDisplayString($setup.findCurrentMetricsMontly(channel.channel?.channelId, slotProps?.data)?.clicks || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", _hoisted_34, _toDisplayString($setup.findCurrentMetricsMontly(channel.channel?.channelId, slotProps?.data)?.conversions || 0), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    (slotProps?.data?.paymentMethod !== $setup.CampaignPaymentMethod.CPM)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.findCurrentMetricsMontly(channel.channel?.channelId, slotProps?.data)?.forPay?.total > 0
                      ? $setup.findCurrentMetricsMontly(channel.channel?.channelId, slotProps?.data)?.forPay?.total
                      : 0.00?.toFixed(2)) + " " + _toDisplayString($setup.findCurrentMetricsMontly(channel.channel?.channelId, slotProps?.data)?.forPay?.currency || 'USD'), 1))
                      : _createCommentVNode("", true),
                    (slotProps?.data?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          ($setup.cpmStats && $setup.cpmStats.hasOwnProperty(slotProps?.data?.id))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString($setup.findOneChannelCpmMetric(
                        $setup.cpmStats[slotProps?.data?.id]?.channels,
                        channel?.channel?.channelId
                    )?.amount || 0.00?.toFixed(2)) + " " + _toDisplayString($setup.findOneChannelCpmMetric($setup.cpmStats[slotProps?.data?.id]?.channels, channel?.channel?.channelId)?.currency
                        || 'USD'), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_39, "0.00 USD"))
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", {
                    class: "button",
                    onClick: ($event: any) => (_ctx.$router.push({ name: 'channel-stat',
                 query: { campaignId: slotProps.data?.id, channelId: channel.channel?.channelId, userId: '' }}))
                  }, _hoisted_42, 8, _hoisted_40)
                ]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              header: "CAMPAIGN TITLE",
              sortField: "number"
            }, {
              header: _withCtx(() => [
                _hoisted_4
              ]),
              body: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "p-d-flex p-ai-center p-text-bold pointer",
                  onClick: ($event: any) => ($setup.user.isAgencyOwner() ?
               $setup.expandItem(data) : null)
                }, [
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(data?.name), 1)
                ], 8, _hoisted_5)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "BRAND",
              sortField: "brand.name"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "p-d-flex p-ai-center pointer",
                  onClick: ($event: any) => ($setup.user.isAgencyOwner() ?
               $setup.expandItem(data) : null)
                }, [
                  (data?.brand?.photo.length > 0)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: data?.brand?.photo,
                        class: "logo-brand"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(data?.brand?.name), 1)
                ], 8, _hoisted_7)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "CAMPAIGN PERIOD",
              sortField: "period"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_10, _toDisplayString($setup.formatDate(data?.dates?.startDate)) + " - " + _toDisplayString($setup.formatDate(data?.dates?.endDate) || 'Until the end of the budget'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "CAMPAIGN STATUS",
              sortField: "status"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(data?.status), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "MONTHLY EARNINGS SO FAR",
              sortField: "status"
            }, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", _hoisted_14, [
                  ($setup.user.isAgencyOwner())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($setup.cpmStats && $setup.cpmStats.hasOwnProperty(data?.id))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.cpmStats[data?.id]?.amount > 0 ? $setup.cpmStats[data?.id]?.amount : 0.00?.toFixed(2)) + " " + _toDisplayString($setup.cpmStats[data?.id]?.currency || 'USD'), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                        (data?.paymentMethod !== $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString($setup.totalChannelsSoFar(data, $setup.user, true)?.total > 0
                      ? $setup.totalChannelsSoFar(data, $setup.user, true)?.total?.toFixed(2) : 0.00?.toFixed(2)) + " " + _toDisplayString($setup.totalChannelsSoFar(data, $setup.user, true)?.currency || 'USD'), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.user?.isCreator())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        (data?.paymentMethod !== $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.getMountlyEarning(data, false)?.forPay?.total > 0
                      ? $setup.getMountlyEarning(data, false)?.forPay?.total : 0.00?.toFixed(2)) + " " + _toDisplayString($setup.getMountlyEarning(data, false)?.forPay?.currency || 'USD'), 1))
                          : _createCommentVNode("", true),
                        (data?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              ($setup.cpmStats)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.cpmStats[data?.id]?.amount > 0 ? $setup.cpmStats[data?.id]?.amount : 0.00?.toFixed(2)) + " " + _toDisplayString($setup.cpmStats[data?.id]?.currency || 'USD'), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            ($setup.user.isAgencyOwner())
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  header: "INFLUENCERS",
                  sortField: "status"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("button", {
                      class: "p-d-flex p-justify-center button-expand",
                      onClick: ($event: any) => ($setup.expandItem(data))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentRowWorkers(data), (item, index) => {
                        return (_openBlock(), _createElementBlock("img", {
                          class: "influencer-img",
                          key: `${index}_g`,
                          style: _normalizeStyle({'z-index': 1000 - index}),
                          src: item?.channel?.photo
                        }, null, 12, _hoisted_22))
                      }), 128))
                    ], 8, _hoisted_21)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Column, null, {
              body: _withCtx(({ data }) => [
                _createElementVNode("div", {
                  class: "button",
                  onClick: ($event: any) => ($setup.user.isAgencyOwner() ? _ctx.$router.push({ name: 'campaign-stat', query: { campaignId: data?.id }})
                : null)
                }, _hoisted_25, 8, _hoisted_23)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "expandedRows"])
      ])
    ])
  ]))
}